/** 看板卡片 / 抽屉展示所需字段（历史 Excel 行与新系统 live_case 共用） */
export interface ComplaintPresentRow {
  date?: string | null;
  deptC?: string | null;
  deptP?: string | null;
  jz?: string | null;
  pm?: string | null;
  lh?: string | null;
  fzr?: string | null;
  cause?: string | null;
  temp?: string | null;
  permanent?: string | null;
}

/** 卡片/抽屉共用的投诉日展示（MM-DD） */
export function complaintShortDate(value: string | null | undefined): string {
  const text = String(value || '').trim();
  const matched = /^(\d{4})-(\d{2}-\d{2})/.exec(text);
  return matched ? matched[2] : text || '—';
}

/** 计划/要求完成日（MM-DD） */
export function complaintShortPlan(value: string | null | undefined): string {
  return complaintShortDate(value);
}

export function complaintDeptChain(row: ComplaintPresentRow): string {
  const from = (row.deptC || '').trim() || '—';
  const to = (row.deptP || '').trim() || '—';
  return `${from} → ${to}`;
}

/** 看板卡片 meta 行：对齐原型「投诉日 · 部门链路 · 机种」 */
export function complaintBoardMeta(row: ComplaintPresentRow): string {
  const date = complaintShortDate(row.date);
  const jz = (row.jz || '').trim() || '—';
  return `${date} 投诉 · ${complaintDeptChain(row)} · ${jz}`;
}

/** 详情抽屉标题下副标题 */
export function complaintDrawerSubtitle(row: ComplaintPresentRow): string {
  const date = (row.date || '').trim() || '—';
  const jz = (row.jz || '').trim() || '—';
  const fzr = (row.fzr || '').trim() || '—';
  return `${date} 投诉 · ${complaintDeptChain(row)} · ${jz} · 负责人 ${fzr}`;
}

export function clipText(value: string | null | undefined, max: number): string {
  const text = (value || '').trim();
  if (!text) return '';
  return text.length > max ? `${text.slice(0, max)}…` : text;
}

export interface ComplaintCardFieldLine {
  label: string;
  text: string;
  highlight?: boolean;
}

/** 看板卡片内「原因 / 对策」摘要，与原型 fields 区块一致 */
export function complaintCardFieldLines(row: ComplaintPresentRow): ComplaintCardFieldLine[] {
  const lines: ComplaintCardFieldLine[] = [];
  const cause = clipText(row.cause, 46);
  if (cause) lines.push({ label: '原因', text: cause });
  const temp = clipText(row.temp, 40);
  if (temp) lines.push({ label: '临时对策', text: temp });
  const permanentRaw = (row.permanent || '').trim();
  if (permanentRaw === '*') {
    lines.push({ label: '永久对策', text: '填「*」，无实质内容', highlight: true });
  } else {
    const permanent = clipText(row.permanent, 40);
    if (permanent) lines.push({ label: '永久对策', text: permanent });
  }
  return lines;
}

export function complaintPartTitle(row: ComplaintPresentRow): string {
  const name = (row.pm || '').trim() || '未命名';
  const code = (row.lh || '').trim();
  return code ? `${name} · ${code}` : name;
}
